import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addNewUserPost } from "../repositories/userRepo";



const initialState = {
  response: {},
  loading: false,
  error: false,
  errorMsg: "",
};
export const addNewAdminData= createAsyncThunk(
  "addNewAdmin",
  async (data, thunkAPI) => {
    const response = await addNewUserPost(data);
    return response;
  }
);
export const addNewAdminSlice = createSlice({
  name: "addNewAdmin",
  initialState,
  extraReducers: {
    [addNewAdminData.pending]: (state) => {
      state.loading = true;
    },
    [addNewAdminData.fulfilled]: (state, action) => {
      state.loading = false;

      state.response = action.payload;
      console.log(action.payload);
    },
    [addNewAdminData.rejected]: (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMsg = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default addNewAdminSlice.reducer;
